/* eslint-disable global-require */

import angular from 'angular';

import CustomTemplateFormController from './form-custom-template.controller';

export default angular.module('autoboard.formCustomTemplate', [])
  .directive('formCustomTemplate', () => {
    'ngInject';

    return {
      controller: CustomTemplateFormController,
      restrict: 'E',
      scope: {
        exit: '&',
        show: '=',
        vehicle: '<',
        customerId: '<?',
      },
      templateUrl: require('./form-custom-template.template.html'),
    };
  })
  .name;
